module.exports = __webpack_public_path__ + "static/media/tacoBell.46373518.webp";